<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>我的评价</p>
    </div>
    <div class="panel-content center_content">
      <div id="searchSection">
        <input
          type="text"
          v-model="queryInfo.experiment_title"
          placeholder="实验名称"
          class="s-input separate"
        >
        <input
          type="date"
          v-model="queryInfo.created"
          placeholder="日期"
          class="s-input separate"
        >
        <input
          type="button"
          value="搜索"
          class="s-btn"
          @click="queryInfo.page=1,search()"
        >
      </div>
      <div id="list">
        <table v-if="tableData.length">
          <tbody>
            <tr class="l_header">
              <th class="itemStatus">实验名称</th>
              <th class="itemStatus">发表日期</th>
              <th class="itemStatus">评分</th>
              <th class="itemStatus">操作</th>
            </tr>
            <tr
              class="item"
              v-for="(item,index) in tableData"
              :key="index"
            >
              <td class="itemStatus">
                <router-link
                  class="see"
                  :to="'/www/experiment?id=' + item.experiment.id"
                  target="_blank"
                >{{ item.experiment.title }}</router-link>
              </td>
              <td class="itemStatus">{{item.created.substr(0, 10)}}</td>
              <td class="itemStatus">{{item.grade}}</td>
              <td class="itemStatus">
                <a
                  class="delete"
                  href="javascript:;"
                  @click="askDelete(item.id)"
                >删除</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-else
        >没有数据</div>
      </div>
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'MyAppraise',
  components: {
    Pagination
  },
  data() {
    return {
      queryInfo: {
        page: 1,
        size: 10,
        userprofile_id: '',
        experiment_title: '',
        created: ''
      },
      tableData: [],
      tableDataCount: 0
    }
  },
  // 函数方法
  methods: {
    // 分页
    pageCallback(data) {
      this.queryInfo.page = data
      this.search()
    },
    async search() {
      this.queryInfo.userprofile_id = this.localUser.profile_id
      await this.$http.get('/experimentappraise/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    async askDelete(id) {
      const url = '/experimentappraise/' + id + '/'
      await this.$parent.showConfirm('确认删除吗?', () => {
        this.$http.put(url, {
          isdel: 1
        }).then((data) => {
          this.$parent.showMsg('删除成功！')
          this.search()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('删除失败！')
        })
      })
    }
  },
  // 计算属性
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    },
    localUser() {
      return this.$store.state.userInfo
    }
  },
  mounted() {
    this.search()
  }
}
</script>

<style scoped>
</style>
